module.exports = __webpack_public_path__ + "img/neogeo_logo-blanc.07f374c7.png";